<template>
  <div>
    <v-toolbar
      tabs
      :style="{
        zIndex: 1,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        borderColor: '#ccc',
      }"
      height="128"
      card
      color="#fff"
    >
      <v-layout row wrap align-center>
        <v-flex xs12>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:item="props">
              <router-link
                :to="props.item.href"
                :is="props.item.disabled ? 'span' : 'router-link'"
              >
                {{ props.item.text }}
              </router-link>
            </template>
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-flex>
        <v-flex xs12>
          <BoxIcon padding="8px" class="mr-3">
            <v-icon medium color="white">add</v-icon>
          </BoxIcon>
          <h1 style="display: inline">Editar ronda</h1>
        </v-flex>
      </v-layout>
    </v-toolbar>
    <div class="schedule-container">
      <v-container fluid grid-list-xl>
        <div class="border-container bg-white pa-4">
          <p>
            <BoxIcon padding="8px" class="mr-3" color="secondary">
              <v-icon medium color="white">bookmark</v-icon>
            </BoxIcon>
            <strong class="text-uppercase subheading font-weight-bold">
              información de la ronda
            </strong>
          </p>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-card flat class="border-container" style="overflow: visible">
                <v-card-text class="py-2">
                  <v-radio-group
                    v-model="form.optionDay"
                    hide-details
                    class="mt-0 pa-0 row_group"
                  >
                    <v-radio
                      color="primary"
                      :key="form.optionDay"
                      label="Solo un día"
                      value="EVENTUAL"
                      class="ma-0 mr-2"
                    />
                    <v-radio
                      color="primary"
                      :key="form.optionDay"
                      label="Por tiempo indefinido"
                      value="PERMANENT"
                      class="ma-0"
                    />
                  </v-radio-group>
                </v-card-text>
              </v-card>
              <v-card
                flat
                class="border-container mt-3 pt-3 pl-3"
                style="overflow: visible"
              >
                <strong>Título</strong>
                <br />
                <input
                  type="text"
                  class="mt-2"
                  style="
                    height: 40px;
                    width: 100%;
                    max-width: 300px;
                    font-size: 1.2em;
                    border-radius: 3px;
                  "
                  v-model="form.name"
                />
              </v-card>
            </v-flex>
            <v-flex xs12 md6>
              <v-card
                flat
                class="py-0 pt-2 px-4 mb-2 border-container"
                style="overflow: visible"
              >
                <div
                  style="
                    max-width: 100px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  v-on:mouseover="mouseOnImage = true"
                  v-on:mouseleave="mouseOnImage = false"
                >
                  <v-flex
                    xs7
                    style="border-radius: 50%; cursor: pointer; padding: 0"
                    :class="[!modals.image ? 'gradiente' : '', 'ma-auto']"
                    @click="modals.showModalImage = true"
                  >
                    <v-img
                      v-if="modals.image === undefined"
                      :src="
                        require('@/assets/panel/modals/AddPhotoIcon@3x.png')
                      "
                    />
                    <v-avatar v-else size="100%" color="grey lighten-4">
                      <v-img :src="modals.image" />
                    </v-avatar>
                  </v-flex>
                  <!-- <br /> -->
                  <v-flex class="d-flex justify-center">
                    <v-expand-transition>
                      <v-btn
                        v-show="mouseOnImage"
                        block
                        class="gradiente"
                        style="border-radius: 33px; padding: 0"
                        dark
                        @click="modals.showModalImage = true"
                      >
                        {{ !modals.image ? 'Añadir foto' : 'Actualizar' }}
                      </v-btn>
                    </v-expand-transition>
                  </v-flex>
                </div>
              </v-card>
              <div v-if="form.optionDay === 'EVENTUAL'" class="general_data">
                <v-card
                  flat
                  class="py-2 px-4 border-container"
                  style="overflow: visible"
                >
                  <v-card-text>
                    <v-layout align-center row fill-height>
                      <span class="font-weight-medium body-2">
                        Periodo de validéz para la ronda
                      </span>
                    </v-layout>
                    <v-layout
                      align-start
                      column
                      fill-height
                      class="mt-2 ml-1 gray--text"
                    >
                      <div class="d-flex">
                        <span style="width: 100px" class="mt-2 mr-2">
                          <strong>Inicia</strong>
                        </span>
                        <v-menu
                          :close-on-content-click="true"
                          :nudge-right="40"
                          lazy
                          transition="scale-transition"
                          offset-y
                          full-width
                          min-width="290px"
                        >
                          <template late v-slot:activator="{ on }">
                            <v-text-field
                              id="first-small"
                              :value="parseTimeFromTimePicker(form.dateStart)"
                              label="Fecha de inicio"
                              prepend-icon="event"
                              readonly
                              solo
                              flat
                              hide-details
                              v-on="on"
                              class="padded"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            header-color="primary"
                            color="secondary"
                            locale="es-419"
                            scrollable
                            v-model="form.dateStart"
                            :min="dateLimitToday"
                          ></v-date-picker>
                        </v-menu>
                      </div>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
            </v-flex>
            <Audience
              ref="audienceRef"
              target-type="ROUND"
              @selectedAudience="onSelectedAudience"
              @selectedItemsIds="onSelectedItemsIds"
              @ready="onReady"
            >
              <template v-slot:titleTarget>
                <span class="pl-3 body-2 font-weight-medium text-uppercase">
                  Selecciona los alumnos para la ronda
                </span>
              </template>
              <template v-slot:titleItems>
                <span
                  class="pt-1 pl-2 body-2 font-weight-medium text-uppercase"
                >
                  Audiencia
                </span>
              </template>
            </Audience>
            <v-flex>
              <p class="body-2 font-weight-medium text-uppercase">
                Selecciona los tutores que pueden solicitar la ronda
              </p>
              <div class="border-container">
                <div class="flex-align_center pa-3">
                  <BoxIcon color="secondary">
                    <v-icon medium color="#fff">group</v-icon>
                  </BoxIcon>
                  <v-layout
                    align-center
                    justify-center
                    row
                    style="margin-top: -20px"
                  >
                    <v-flex xs6 md6 class="pa-0">
                      <v-text-field
                        v-model="searchTutor"
                        label="Buscar tutores"
                        class="border-container"
                        prepend-inner-icon="search"
                        clearable
                        solo
                        flat
                        hide-details
                        @click:clear="clearSearch"
                        @keyup.enter="getParentsRound"
                      />
                    </v-flex>
                  </v-layout>
                  <p class="my-3 title font-weight-medium">Tutores</p>
                  <v-card flat class="border-container mx-3">
                    <v-card-text class="px-0 py-0">
                      <v-data-table
                        v-model="selected"
                        :rows-per-page-items="[25, 50, 100]"
                        rows-per-page-text="Registros por página"
                        :headers="headers"
                        :items="items"
                        :total-items="totalItems"
                        :pagination.sync="pagination"
                        no-results-text="No se encontraron coincidencias"
                        no-data-text="No hay registros"
                        select-all
                        @update:pagination="getParentsRound"
                      >
                        <v-progress-linear
                          v-slot:progress
                          color="primary"
                          indeterminate
                        ></v-progress-linear>
                        <template v-slot:headers="props">
                          <tr>
                            <th
                              style="
                                width: 78px;
                                max-width: 78px;
                                min-width: 78px;
                              "
                            >
                              <v-checkbox
                                :input-value="props.all"
                                :indeterminate="props.indeterminate"
                                primary
                                color="primary"
                                hide-details
                                @click.stop="toggleAll"
                              ></v-checkbox>
                            </th>
                            <th
                              v-for="header in props.headers"
                              :key="header.text"
                            >
                              {{ header.text }}
                            </th>
                          </tr>
                        </template>
                        <template v-slot:items="props">
                          <tr>
                            <td
                              style="
                                width: 78px;
                                max-width: 78px;
                                min-width: 78px;
                              "
                            >
                              <v-checkbox
                                color="primary"
                                v-model="props.selected"
                                primary
                                hide-details
                              >
                              </v-checkbox>
                            </td>
                            <td>{{ props.item.firstName }}</td>
                            <td>{{ props.item.lastName }}</td>
                            <td>{{ props.item.email }}</td>
                          </tr>
                        </template>
                        <template v-slot:no-data>
                          No hay registros para filtrar
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </v-flex>
            <v-flex>
              <v-layout align-center justify-end class="pa-4">
                <v-btn
                  color="primary"
                  flat="flat"
                  class="border-container ma-1"
                  @click="cancelEdit"
                >
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  flat="flat"
                  class="border-container ma-1 pa-2"
                  :disabled="!isValidCreateBtn()"
                  @click="createRound"
                >
                  Guardar
                </v-btn>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
      </v-container>
    </div>
    <EditImage
      title="Añadir imagen"
      v-on:loaded="processImage($event)"
      v-model="modals.showModalImage"
    />
    <Loading v-model="createOptions.loading" text="Cargando..." />
    <Error v-model="createOptions.showError" :text="createOptions.message" />
    <Success
      v-model="createOptions.showSuccess"
      :text="createOptions.message"
    />
    <ConfirmCancel
      :show="modals.showConfirm"
      title="No se han guardado los cambios realizados"
      description="¿Quieres salir sin guardar los cambios?"
      cancel-text="No, Cancelar"
      ok-text="Sí, Salir"
      @change="onConfirmCancel"
    />
  </div>
</template>

<script>
import { InitialAudienceData } from '../../../../../Mixins/audience.js'
import { _isSomeDifferent, _keyVal } from '../../../../../utils/genericUtils.js'
import Error from '../../../../Dialogs/Error.vue'
import Loading from '../../../../Dialogs/Loading.vue'
import Success from '../../../../Dialogs/Success.vue'
import ConfirmCancel from '../../../../Dialogs/confirm_new_ui.vue'
import EditImage from '../../../../Modals/EditImage.vue'
import ArrowStep from '../../../../generic/arrowStep.vue'
import Audience from '../../../../generic/audience.vue'
import BoxIcon from '../../../../generic/boxIcon.vue'
import CircleNumber from '../../../../generic/circleNumber.vue'
import CustomChip from '../../../../generic/customChip.vue'
import RadioBox from '../../../../generic/radioBox.vue'
import TargetAudience from '../../../../generic/targetAudience.vue'
export default {
  components: {
    CircleNumber,
    ArrowStep,
    TargetAudience,
    BoxIcon,
    RadioBox,
    CustomChip,
    Loading,
    Error,
    Success,
    EditImage,
    ConfirmCancel,
    Audience,
  },
  data: () => ({
    modals: {
      image: undefined,
      showModalImage: '',
      showConfirm: false,
    },
    mouseOnImage: false,
    dateLimitToday: '',
    form: {
      /**
       * @type {'PERMANENT'|'EVENTUAL'}
       */
      optionDay: 'EVENTUAL',
      dateStart: '',
      // dateEnds: '',
      name: '',
      /**
       * @type {'INSTITUTION'|'LEVELS'|'EXTRA_LEVELS'|'GROUPS'|'SUBGROUPS'|'STUDENTS'}
       */
      target: 'INSTITUTION',
      image: undefined,
      /**
       * @type {Array<number>}
       */
      selectedItemsIds: [],
    },
    breadcrumbs: [
      {
        text: 'Rondas',
        disabled: false,
        href: '/es/panel/rounds',
      },
      {
        text: 'Editar',
        disabled: true,
        href: '/es/panel/rounds/edit',
      },
    ],
    createOptions: {
      showSuccess: false,
      showError: false,
      loading: false,
      message: '',
    },
    headers: [
      {
        text: 'Nombre',
      },
      {
        text: 'Apellidos',
      },
      {
        text: 'Correo',
      },
    ],
    items: [],
    totalItems: 0,
    selected: [],
    pagination: {
      page: 1,
      rowsPerPage: 25,
    },
    searchTutor: '',
    initialData: {
      name: '',
      image: undefined,
      optionDay: '',
      createdAt: 0,
      institutional: false,
      targetAudienceIds: [],
      assignedParentIds: [],
    },
  }),
  async mounted() {
    this.createOptions.loading = true
  },
  methods: {
    async onReady() {
      await this.getInfo()
      this.createOptions.loading = false
    },
    processImage(e) {
      this.modals.image = e
    },
    clearSearch() {
      this.searchTutor = ''
      this.getParentsRound()
    },
    async getParentsRound() {
      const params = {
        institutional: this.form.target === 'INSTITUTION' ? true : undefined,
        levelIds:
          this.form.target === 'LEVELS'
            ? this.form.selectedItemsIds
            : undefined,
        extraLevelIds:
          this.form.target === 'EXTRA_LEVELS'
            ? this.form.selectedItemsIds
            : undefined,
        gradeGroupIds:
          this.form.target === 'GROUPS'
            ? this.form.selectedItemsIds
            : undefined,
        subgroupIds:
          this.form.target === 'SUBGROUPS'
            ? this.form.selectedItemsIds
            : undefined,
        studentIds:
          this.form.target === 'STUDENTS'
            ? this.form.selectedItemsIds
            : undefined,
        offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
        size: this.pagination.rowsPerPage,
        search: this.searchTutor,
      }

      try {
        const { data } = await this.$store.dispatch(
          'round/getParentsRound',
          params
        )

        this.items = data.data
        this.totalItems = data.total
      } catch (error) {
        console.log(error)
        this.items = []
        this.totalItems = 0
        this.createOptions.showError = true
        this.createOptions.message = 'Error al solicitar tutores'
      }
    },
    async createRound() {
      try {
        this.createOptions.loading = true

        const body = {
          name: this.form.name,
          roundType: this.form.optionDay,
          image:
            this.modals.image !== undefined
              ? this.modals.image.split(',')[1]
              : undefined,
          date:
            this.form.optionDay === 'EVENTUAL'
              ? this._parseTimeToLocalEpoch(this.form.dateStart)
              : undefined,
          parentIds: this.selected.map((e) => e.id),
          institutional: this.form.target === 'INSTITUTION',
          levelIds:
            this.form.target === 'LEVELS'
              ? this.form.selectedItemsIds
              : undefined,
          extraLevelIds:
            this.form.target === 'EXTRA_LEVELS'
              ? this.form.selectedItemsIds
              : undefined,
          gradeGroupIds:
            this.form.target === 'GROUPS'
              ? this.form.selectedItemsIds
              : undefined,
          subgroupIds:
            this.form.target === 'SUBGROUPS'
              ? this.form.selectedItemsIds
              : undefined,
          studentIds:
            this.form.target === 'STUDENTS'
              ? this.form.selectedItemsIds
              : undefined,
        }

        await this.$store.dispatch('round/editCollegeRound', {
          data: body,
          idRound: this.$route.params.id,
        })

        this.createOptions.message = 'Ronda editada con éxito.'
        this.createOptions.showSuccess = true

        const time = setTimeout(() => {
          this.$router.push({ name: 'Rounds' })
          clearTimeout(time)
        }, 2000)
      } catch (error) {
        console.log(error)
        const customErrors = {
          400: 'No se tiene permiso para editar la ronda.',
          404: 'No se encontró la ronda.',
        }

        this.createOptions.showSuccess = false
        this.createOptions.showError = true
        this.createOptions.message = customErrors[error.response.status]
          ? customErrors[error.response.status]
          : 'Error al editar ronda'
      } finally {
        this.createOptions.loading = false
      }
    },
    cancelEdit() {
      const tempObj = {
        name: this.form.name,
        image: this.modals.image,
        optionDay: this.form.optionDay,
        createdAt: this.form.dateStart,
        institutional: this.form.target === 'INSTITUTION',
        targetAudienceIds: [],
        assignedParentIds: this.selected.map((e) => e.id).sort(),
      }

      tempObj.targetAudienceIds = this.form.selectedItemsIds

      _isSomeDifferent(
        _keyVal(Object.values(tempObj)),
        _keyVal(Object.values(structuredClone(this.initialData)))
      )
        ? (this.modals.showConfirm = true)
        : this.$router.back()
    },
    onConfirmCancel(e) {
      if (e === false) {
        this.modals.showConfirm = false
      } else {
        this.$router.back()
      }
    },
    isValidCreateBtn() {
      if (
        this.createOptions.loading ||
        this.createOptions.showSuccess ||
        this.createOptions.showError ||
        this.selected.length == 0 ||
        this.form.name.trim().length === 0 ||
        (this.form.target !== 'INSTITUTION' &&
          this.form.selectedItemsIds.length === 0)
      ) {
        return false
      }
      return true
    },
    /**
     * accept a string like so `"2023-11-01"`
     */
    parseTimeFromTimePicker(date = '') {
      if (date === '') return ''

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    _parseTimeToLocalEpoch(date) {
      const [year, month, day] = date.split('-')
      return new Date(`${month}/${day}/${year}`).getTime()
    },
    onSelectedAudience(selected) {
      this.form.target = selected
    },
    onSelectedItemsIds(ids) {
      this.form.selectedItemsIds = ids
    },
    async initLevelsGradeGroupslevels() {
      try {
        const { data } = await this.$store.dispatch('tutor/getLevelsExtraTool')

        return data.entity
      } catch (error) {
        console.log(error)
        return
      }
    },
    async getInfo() {
      try {
        const { data } = await this.$store.dispatch(
          'round/getDetailRound',
          this.$route.params.id
        )

        const temp = new Map(Object.entries(data.audience))

        this.selected = data.assignedParentIds.map((e) => ({ id: e }))
        this.modals.image = data.imageStorage && data.imageStorage.miniObjUrl

        let tempAudience = new InitialAudienceData()
        if (temp.get('institutional') === true) {
          this.initialData.targetAudienceIds = []
          tempAudience = new InitialAudienceData('INSTITUTION')
        }
        if (temp.has('levelIds')) {
          this.initialData.targetAudienceIds = temp.get('levelIds')
          tempAudience = new InitialAudienceData('LEVELS', temp.get('levelIds'))
        }
        if (temp.has('extraLevelIds')) {
          this.initialData.targetAudienceIds = temp.get('extraLevelIds')
          tempAudience = new InitialAudienceData(
            'EXTRA_LEVELS',
            temp.get('extraLevelIds')
          )
        }
        if (temp.has('gradeGroupIds')) {
          this.initialData.targetAudienceIds = temp.get('gradeGroupIds')
          tempAudience = new InitialAudienceData(
            'GROUPS',
            temp.get('gradeGroupIds')
          )
        }
        if (temp.has('subgroupIds')) {
          this.initialData.targetAudienceIds = temp.get('subgroupIds')
          tempAudience = new InitialAudienceData(
            'SUBGROUPS',
            temp.get('subgroupIds')
          )
        }
        if (temp.has('studentIds')) {
          this.initialData.targetAudienceIds = temp.get('studentIds')
          tempAudience = new InitialAudienceData(
            'STUDENTS',
            temp.get('studentIds')
          )
        }

        if (data.date !== undefined) {
          this.form.dateStart = new Date(data.date).toLocaleDateString('sv-SE')
        } else {
          this.form.dateStart = new Date(data.createdAt).toLocaleDateString(
            'sv-SE'
          )
          this.form.dateEnds = new Date(data.expDate).toLocaleDateString(
            'sv-SE'
          )
        }
        this.form = {
          ...this.form,
          name: data.name,
          optionDay: data.roundType,
        }

        // DATA TO COMPARE ON CANCEL BTN
        this.initialData.name = data.name
        this.initialData.optionDay = data.roundType
        this.initialData.createdAt = this.form.dateStart
        this.initialData.institutional = data.audience.institutional
        this.initialData.assignedParentIds = data.assignedParentIds.sort()
        this.initialData.image = this.modals.image
        this.$refs.audienceRef.initialData(tempAudience)
      } catch (error) {
        console.log(error)
      }
    },
    toggleAll() {
      if (this.selected.length) this.selected = []
      else this.selected = this.items.slice()
    },
  },
}
</script>

<style scoped>
.schedule-container {
  background-color: #f5f5f5;
  overflow-y: scroll;
  height: calc(100vh - 192px);
}
.border-container {
  padding: 1px;
  border: 1px solid;
  border-color: #ccc !important;
  border-radius: 0.5rem;
}
.pagination {
  display: flex;
  justify-content: center;
}
.loading_height {
  height: 300px;
}
.items_box_pills {
  max-height: 300px;
  overflow-y: scroll;
}
/* reset global css */
::v-deep .v-btn {
  text-transform: initial;
}
::v-deep .v-stepper,
::v-deep .v-stepper__header {
  background-color: initial;
  box-shadow: none;
}
::v-deep .v-stepper__header {
  overflow: hidden;
}
::v-deep .v-stepper__content {
  padding-left: 0;
  padding-right: 0;
}

::v-deep .row_group .v-input--radio-group__input {
  display: flex;
  justify-content: space-evenly;
  flex-direction: row;
}
::v-deep .v-datatable.v-table > thead {
  display: table;
  width: 100%;
  table-layout: fixed;
}

table.v-table > thead tr {
  background-color: #dddddd;
  height: 40px;
}

::v-deep .v-datatable.v-table > tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
/* generic */
.bg-white {
  background-color: white;
}
</style>
